<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="10000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-overlay :value="!loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-form v-if="document && loader" id="uploaddocuments_form" @submit.prevent="submit" v-model="isValid">
      <v-row dense justify="center">
        <v-col cols="10" sm="10" md="10">
          <input type="hidden" :value="application_form_data.admission_form_id" name="admission_form_id" />
        </v-col></v-row>


      <v-row dense justify="center">
        <v-col cols="10" sm="10" md="10">
          <v-alert v-if="org_id == 'sbpps'" text>
            <div v-if="document_instructions" v-html="document_instructions"></div>
            <div v-else>
              <strong>Note: </strong>
              <ul>
                <li>
                  File should be in
                  <span v-for="(img, i) in imagetype" :key="i">
                    {{ img.imagetype }}
                  </span>
                  Format.
                </li>
                <li>
                  Size of uploading documents should be <= {{ imagesize / 1000000 }} MB </li>
                <li>
                  File format for Child/Parent photo should be an
                  image and not in pdf.
                </li>
              </ul>
            </div>
            <div v-if="mandatory_document_type_list.length > 0">
              <br />
              <strong>Mandatory Documents: </strong>
              <ol>
                <li type="1" v-for="(doc, i) in mandatory_document_type_list" :key="i">
                  {{ doc }}
                </li>
              </ol>
            </div>
            <div v-if="additional_document_type_list.length > 0">
              <br />
              <strong>Additional Documents: </strong>
              <ol>
                <li type="1" v-for="(doc, i) in additional_document_type_list" :key="i">
                  {{ doc }}
                </li>
              </ol>
            </div>
          </v-alert>
          <v-alert v-else type="warning" text>
            <div v-if="document_instructions" v-html="document_instructions"></div>
            <div v-else>
              <strong>Note: </strong>
              <ul>
                <li>
                  File should be in
                  <span v-for="(img, i) in imagetype" :key="i">
                    {{ img.imagetype }}
                  </span>
                  Format.
                </li>
                <li>
                  Size of uploading documents should be <= {{ imagesize / 1000000 }} MB </li>
                <li>
                  File format for Child/Parent photo should be an
                  image and not in pdf.
                </li>
                <li v-if="org_id == 'vvp'">
                  Birth certificate is compulsory for std I
                </li>
                <li v-if="org_id == 'vvp'">
                  Leaving Certificate is compulsory for std II to std X
                </li>
                <li v-if="org_id == 'eps'">
                  Latest passport size photographs of the child, mother, father, (and guardian if applicable)
                </li>
                <li v-if="org_id == 'eps'">
                  Address proof (Aadhaar Card / electricity bill / LPG connection receipt / bank passbook / registered
                  rent agreement)
                </li>
                <li v-if="org_id == 'eps'">
                  Child’s Aadhaar Card No.
                </li>
                <li v-if="org_id == 'eps'">
                  Child’s report card of the previous school
                </li>
                <li v-if="org_id == 'uwws'">
                  Mother and Father Photo and Sign Should Be Replicated In Case Of Single Parent Case.
                </li>
              </ul>
            </div>



            <!-- {{imagetype}} -->
            <div v-if="mandatory_document_type_list.length > 0">
              <br />
              <strong>Mandatory Documents: </strong>
              <ol>
                <li type="1" v-for="(doc, i) in mandatory_document_type_list" :key="i">
                  {{ doc }}
                </li>
              </ol>
            </div>

            <div v-if="additional_document_type_list.length > 0">
              <br />
              <strong>Additional Documents: </strong>
              <ol>
                <li type="1" v-for="(doc, i) in additional_document_type_list" :key="i">
                  {{ doc }}
                </li>
              </ol>
            </div>
          </v-alert>
        </v-col>
      </v-row>
      <span v-if="imageSizeFlag">
        <v-col cols="12" xs="12" sm="12">
          <center>
            <p class="slide">
              File size should be less than {{ imagesize / 1000000 }}MB!
            </p>
          </center>
        </v-col>
      </span>
      <span v-if="imageTypeFlag">
        <v-col cols="12" xs="12" sm="12">
          <center>
            <p class="slide">
              File in
              <span v-for="(img, i) in imagetype" :key="i">
                {{ img.imagetype }}
              </span>
              Format!!!
            </p>
          </center>
        </v-col>
      </span>
      <v-row dense justify="center">
        <v-col cols="4" sm="4" md="4">
          <v-autocomplete dense :items="document_type_list" name="documenttype" :required="true"
            :rules="true ? [(v) => !!v || 'Document type is required'] : []" :clearable="true ? false : true"
            return-object single-line :prepend-icon="true ? 'mdi-file' : 'mdi-file'" outlined
            hint="Select the type of document" persistent-hint></v-autocomplete>
        </v-col>
        <v-col cols="4" sm="4" md="4">
          <template>
            <!-- <v-file-input
              :rules="rules"
              :required="true"
              :accept="file_upload_config.allowed_type"
              :placeholder="
                `Upload file size limit ${file_upload_config.max_size /
                  1000000} MB!`
              "
              prepend-icon="mdi-attachment"
              label="Choose File"
              show-size
              v-model="file"
              name="doc"
            ></v-file-input> -->
            <v-file-input :required="true" :placeholder="`Upload file size limit ${imagesize / 1000000} MB!`"
              prepend-icon="mdi-attachment" label="Choose File" show-size v-model="file" name="doc"
              @change="validateFile"></v-file-input>
          </template>
        </v-col>

        <v-col cols="2" sm="2" md="2">
          <v-btn class="ma-2" :color="isValid ? 'primary darken-1' : 'grey lighten-1'" @click="submit"
            :disabled="!isValid || imageTypeFlag || imageSizeFlag">
            <v-icon dark> mdi-cloud-upload </v-icon> Upload
          </v-btn>
        </v-col>
      </v-row>

    </v-form>

    <v-row dense justify="center" v-if="document_list.length > 0">
      <v-col cols="10" sm="10" md="10">
        <template>
          <v-simple-table fixed-header>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Document Name</th>
                  <!-- 
                  <th class="text-left">Remark</th> -->
                  <th class="text-left">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in document_list" :key="i">
                  <td>{{ item.documenttype }}</td>

                  <!-- <td>{{ item.remark }}</td> -->
                  <td>
                    <v-btn text icon @click="deleteApplicationDocument(item)" color="warning" title="delete">
                      <v-icon dark>mdi-delete</v-icon>
                    </v-btn>

                    <v-btn text color="primary" icon title="download">
                      <a :href="awspath + item.documentlink" target="_blank" style="text-decoration: none">
                        <v-icon>mdi-file-download</v-icon>
                      </a>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>
      </v-col>
    </v-row>
    <br />
    <v-row dense justify="center" v-if="document_list.length == 0">
      <v-col cols="10" sm="10" md="10">
        <v-alert icon="mdi-file-document-box-remove" prominent text type="error">
          Not Uploaded any documents yet.
        </v-alert>
      </v-col>
    </v-row>

    <v-row dense justify="center" v-if="admission_declaration != ''">
      <span v-html="admission_declaration"></span>
    </v-row>

    <v-row dense justify="center" v-if="admission_declaration_accepted != null">
      <v-col cols="10" sm="10" md="10">
        <v-checkbox v-model="admission_declaration_accepted.field_value" :name=admission_declaration_accepted.field_name
          :value=admission_declaration_accepted.field_value color="primary darken-1"
          :label=admission_declaration_accepted.field_display_name @change="checkdeclarations()" :rules="admission_declaration_accepted.required
              ? [
                v =>
                  !!v ||
                  ' This is required'
              ]
              : []
            "></v-checkbox>
      </v-col>
    </v-row>

    <v-dialog v-model="cropDialog" max-width="700px">
      <v-card>
        <v-card-title>Crop Image</v-card-title>

        <v-card-text>
          <div ref="imageContainer" style="position: relative; display: inline-block;">
            <img ref="cropImage" :src="cropImageSrc" style="max-width:100%; display:block;" />

            <div class="crop-box" :style="cropStyle" @mousedown.prevent="startMove">
              <div class="resize top" @mousedown.stop.prevent="startResize('top')"></div>
              <div class="resize bottom" @mousedown.stop.prevent="startResize('bottom')"></div>
              <div class="resize left" @mousedown.stop.prevent="startResize('left')"></div>
              <div class="resize right" @mousedown.stop.prevent="startResize('right')"></div>

              <div class="corner top-left" @mousedown.stop.prevent="startResize('top-left')">
                <span class="hor"></span>
                <span class="ver"></span>
              </div>

              <div class="corner top-right" @mousedown.stop.prevent="startResize('top-right')">
                <span class="hor"></span>
                <span class="ver"></span>
              </div>

              <div class="corner bottom-left" @mousedown.stop.prevent="startResize('bottom-left')">
                <span class="hor"></span>
                <span class="ver"></span>
              </div>

              <div class="corner bottom-right" @mousedown.stop.prevent="startResize('bottom-right')">
                <span class="hor"></span>
                <span class="ver"></span>
              </div>

            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="applySquareCrop">Crop</v-btn>
          <v-btn text @click="cropDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      isValid: true,
      loader: false,
      snackbar_msg: "",
      color: "",
      awspath: "",
      org_id: "",
      snackbar: false,
      application_form_data: {
        admission_form_no: "",
        admission_form_id: "",
        display_admission_form_no: ""
      },
      document: null,
      document_list: {},
      document_type_list: null,
      file_upload_config: { allowed_type: "", max_size: 1000 },
      file: null,
      imagesize: null,
      imagetype: null,
      imageTypeFlag: false,
      imageSizeFlag: false,
      mandatory_document_type_list: [],
      additional_document_type_list: [],
      admission_declaration: {},
      admission_declaration_accepted: {},
      document_instructions: "",
      cropDialog: false,
      cropImageSrc: null,
      cropTop: 0,
      cropLeft: 0,
      cropWidth: 200,
      cropHeight: 200,
      moving: false,
      resizing: null,
    };
  },
  methods: {
    checkdeclarations() {
      this.loader = false;
      const data = {
        admission_form_id: this.application_form_data.admission_form_id,
        admission_declaration_accepted: this.admission_declaration_accepted.field_value,
      };
      axios
        .post("/admissionForm/checkAdmissionDeclarations", data)
        .then((res) => {
          if (res.data.form_saved == "YES") {
            this.$store.commit("setform_progress", res.data.form_progress);
            this.getform();
          } else {
            this.showSnackbar("#b71c1c", "Unable to delete...!"); // show snackbar on success
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Error...!"); // show snackbar on success
        });
    },
    deleteApplicationDocument(item) {
      this.loader = false;
      axios
        .post("/admissionForm/deleteApplicationDocument", {
          app_doc_id: item.documentid,
          application_form_id: this.application_form_data.admission_form_id,
        })
        .then((res) => {
          if (res.data.form_saved == "YES") {
            this.showSnackbar("#4caf50", "Deleted Successfully...!"); // show snackbar on success
            this.getform();
          } else {
            this.showSnackbar("#b71c1c", "Unable to delete...!"); // show snackbar on success
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Error...!"); // show snackbar on success
        });
    },

    submit: function (e) {
      // console.log("file",this.file)
      if (this.file == null) {
        alert("Please upload file");
        return;
      }
      this.loader = false;
      var form = document.getElementById("uploaddocuments_form");
      var formData = new FormData(form);
      axios
        .post("/admissionForm/saveUploadDocuments", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          // success callback

          if (response.data.form_saved == "YES") {
            this.showSnackbar("#4caf50", "Saved Successfully...!"); // show snackbar on success
            this.$store.commit("setform_progress", response.data.form_progress);
            this.loader = true;
            this.file = null;
            this.getform();
          } else {
            this.showSnackbar(
              "#4caf50",
              "Something went wrong while uploading file!!!"
            );
            this.loader = true;
            this.file = null;
            this.getform();
          }
        })
        .catch((error) => {
          this.showSnackbar("#4caf50", "Something went wrong!!!");
          this.loader = true;
          this.file = null;
          this.getform();
        });
    },

    validateFile() {
      if (!this.file) return;

      let file_size = this.file.size;
      let ext = this.file.name.split(".").pop().toLowerCase();

      // Size check
      if (file_size > this.imagesize) {
        this.imageSizeFlag = true;
        this.file = null;
        return;
      } else {
        this.imageSizeFlag = false;
      }

      // Type check
      let allowed = this.imagetype.map(i => i.imagetype.toLowerCase());

      if (!allowed.includes(ext)) {
        this.imageTypeFlag = true;
        this.file = null;
        return;
      } else {
        this.imageTypeFlag = false;
      }

      // If image → open crop
      if (["jpg", "jpeg", "png", "webp"].includes(ext)) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.cropImageSrc = e.target.result;
          this.cropDialog = true;
        };
        reader.readAsDataURL(this.file);
      }
    },

    getform() {
      axios
        .post("/admissionForm/getUploadDocuments", this.application_form_data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.document = res.data.document;
            this.document_list = res.data.document_list;
            this.document_type_list = res.data.document_type_list;
            this.mandatory_document_type_list =
              res.data.mandatory_document_type_list;
            this.additional_document_type_list = res.data.additional_document_type_list;
            this.file_upload_config = res.data.file_upload_config;
            this.rules = [
              (v) => !!v || "File is required",
              (value) =>
                !value ||
                value.size < this.file_upload_config.max_size ||
                "File size should be less than " +
                this.file_upload_config.max_size / 1000000 +
                "MB!",
            ];
            this.loader = true;
            this.$store.commit("setform_progress", res.data.form_progress);
            this.imagesize = res.data.imagesize;
            this.imagetype = res.data.imagetype;
            this.admission_declaration = res.data.admission_declaration;
            this.admission_declaration_accepted = res.data.admission_declaration_accepted;
            this.document_instructions = res.data.document_instructions;
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
   applySquareCrop() {
  const img = this.$refs.cropImage;
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  const scaleX = img.naturalWidth / img.width;
  const scaleY = img.naturalHeight / img.height;

  let cropX = this.cropLeft * scaleX;
  let cropY = this.cropTop * scaleY;
  let cropW = this.cropWidth * scaleX;
  let cropH = this.cropHeight * scaleY;
  
  cropX = Math.max(0, cropX);
  cropY = Math.max(0, cropY);

  if (cropX + cropW > img.naturalWidth) {
    cropW = img.naturalWidth - cropX;
  }

  if (cropY + cropH > img.naturalHeight) {
    cropH = img.naturalHeight - cropY;
  }

  canvas.width = cropW;
  canvas.height = cropH;

  ctx.drawImage(
    img,
    cropX,
    cropY,
    cropW,
    cropH,
    0,
    0,
    cropW,
    cropH
  );

  canvas.toBlob((blob) => {
    const croppedFile = new File([blob], this.file.name, {
      type: this.file.type,
    });

    this.file = croppedFile;

    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(croppedFile);

    const fileInput = document.querySelector('input[name="doc"]');
    if (fileInput) {
      fileInput.files = dataTransfer.files;
    }
  });

  this.cropDialog = false;
}
,

    startMove() {
      this.moving = true;
      document.addEventListener("mousemove", this.moveSquare);
      document.addEventListener("mouseup", this.stopMove);
    },

    moveSquare(e) {
  if (!this.moving) return;

  const container = this.$refs.imageContainer.getBoundingClientRect();
  const img = this.$refs.cropImage;

  let x = e.clientX - container.left - this.cropWidth / 2;
  let y = e.clientY - container.top - this.cropHeight / 2;

  // Constrain inside image
  x = Math.max(0, Math.min(x, img.width - this.cropWidth));
  y = Math.max(0, Math.min(y, img.height - this.cropHeight));

  this.cropLeft = x;
  this.cropTop = y;
},

    stopMove() {
      this.moving = false;
      document.removeEventListener("mousemove", this.moveSquare);
      document.removeEventListener("mouseup", this.stopMove);
    },

    startResize(direction) {
      this.resizing = direction;
      document.addEventListener("mousemove", this.resizeCrop);
      document.addEventListener("mouseup", this.stopResize);
    },

    stopResize() {
      this.resizing = null;
      document.removeEventListener("mousemove", this.resizeCrop);
      document.removeEventListener("mouseup", this.stopResize);
    },

    resizeCrop(e) {
      if (!this.resizing) return;

      const img = this.$refs.cropImage;
      const rect = img.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;

      switch (this.resizing) {
        case "top":
          let diffTop = this.cropTop - mouseY;
          this.cropTop = mouseY;
          this.cropHeight += diffTop;
          break;
        case "bottom":
          this.cropHeight = mouseY - this.cropTop;
          break;
        case "left":
          let diffLeft = this.cropLeft - mouseX;
          this.cropLeft = mouseX;
          this.cropWidth += diffLeft;
          break;
        case "right":
          this.cropWidth = mouseX - this.cropLeft;
          break;

        // Corners
        case "top-left":
          let diffTLX = this.cropLeft - mouseX;
          let diffTLY = this.cropTop - mouseY;
          this.cropLeft = mouseX;
          this.cropTop = mouseY;
          this.cropWidth += diffTLX;
          this.cropHeight += diffTLY;
          break;
        case "top-right":
          let diffTRX = mouseX - (this.cropLeft + this.cropWidth);
          let diffTRY = this.cropTop - mouseY;
          this.cropTop = mouseY;
          this.cropWidth += diffTRX;
          this.cropHeight += diffTRY;
          break;
        case "bottom-left":
          let diffBLX = this.cropLeft - mouseX;
          let diffBLY = mouseY - (this.cropTop + this.cropHeight);
          this.cropLeft = mouseX;
          this.cropWidth += diffBLX;
          this.cropHeight += diffBLY;
          break;
        case "bottom-right":
          this.cropWidth = mouseX - this.cropLeft;
          this.cropHeight = mouseY - this.cropTop;
          break;
      }

      // Prevent negative sizes
      if (this.cropWidth < 50) this.cropWidth = 50;
      if (this.cropHeight < 50) this.cropHeight = 50;
      // Constrain within image
if (this.cropLeft < 0) {
  this.cropWidth += this.cropLeft; // reduce width
  this.cropLeft = 0;
}
if (this.cropTop < 0) {
  this.cropHeight += this.cropTop; // reduce height
  this.cropTop = 0;
}
if (this.cropLeft + this.cropWidth > img.width) {
  this.cropWidth = img.width - this.cropLeft;
}
if (this.cropTop + this.cropHeight > img.height) {
  this.cropHeight = img.height - this.cropTop;
}

    },
    

  },
  mounted() {
    this.application_form_data = this.$store.getters.application_form_data;
    this.awspath = localStorage.getItem("awspath");
    this.org_id = localStorage.getItem("EPS-tenant");

    // EPS-tenant
    this.getform();
  },
  computed: {
    cropStyle() {
      return {
        position: "absolute",
        top: this.cropTop + "px",
        left: this.cropLeft + "px",
        width: this.cropWidth + "px",
        height: this.cropHeight + "px",
        border: "2px dotted red",
        boxSizing: "border-box"
      };
    }
  }

};
</script>
<style scoped>
.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
}

.crop-box {
  position: absolute;
}

.resize {
  position: absolute;
  background: transparent;
}

.resize.top {
  top: -5px;
  left: 0;
  width: 100%;
  height: 10px;
  cursor: ns-resize;
}

.resize.bottom {
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 10px;
  cursor: ns-resize;
}

.resize.left {
  left: -5px;
  top: 0;
  width: 10px;
  height: 100%;
  cursor: ew-resize;
}

.resize.right {
  right: -5px;
  top: 0;
  width: 10px;
  height: 100%;
  cursor: ew-resize;
}

/* .corner {
  position: absolute;
  width: 10px;
  height: 10px;
  background: red;
  z-index: 10;
} */

/* Corner positions */
.corner {
  position: absolute;
  width: 20px;
  /* total clickable area */
  height: 20px;
  z-index: 10;
}

.crop-box {
  position: absolute;
  border: 2px dotted red;
  /* main dotted border */
  box-sizing: border-box;
}

.crop-box .corner {
  position: absolute;
  width: 20px;
  height: 20px;
  z-index: 10;
}

.crop-box .corner span {
  position: absolute;
  background-color: red;
}

.crop-box .corner .hor {
  height: 3px;
  width: 14px;
}

.crop-box .corner .ver {
  width: 3px;
  height: 14px;
}

.crop-box .corner.top-left .hor {
  top: 0;
  left: 0;
}

.crop-box .corner.top-left .ver {
  top: 0;
  left: 0;
}

.crop-box .corner.top-right .hor {
  top: 0;
  right: 0;
}

.crop-box .corner.top-right .ver {
  top: 0;
  right: 0;
}

.crop-box .corner.bottom-left .hor {
  bottom: 0;
  left: 0;
}

.crop-box .corner.bottom-left .ver {
  bottom: 0;
  left: 0;
}

.crop-box .corner.bottom-right .hor {
  bottom: 0;
  right: 0;
}

.crop-box .corner.bottom-right .ver {
  bottom: 0;
  right: 0;
}

.crop-box .corner.top-left {
  top: -4px;
  left: -4px;
  cursor: nwse-resize;
}

.crop-box .corner.top-right {
  top: -4px;
  right: -4px;
  cursor: nesw-resize;
}

.crop-box .corner.bottom-left {
  bottom: -4px;
  left: -4px;
  cursor: nesw-resize;
}

.crop-box .corner.bottom-right {
  bottom: -4px;
  right: -4px;
  cursor: nwse-resize;
}
</style>
